import React from 'react';
import '../styles/theme.css';
import '../styles/auth.css';

type AuthLayoutProps = {
  title: string;
  subtitle?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({ title, subtitle, footer, children }) => {
  return (
    <div className="auth-wrapper">
      <div className="auth-hero">
        <div className="brand">
          <span className="brand-mark" />
          Categorizer
        </div>
        <div className="hero-copy">
          <h2 className="hero-title">Turn unstructured data into structured insight.</h2>
          <p className="hero-subtitle">
            Our automatic categorization system helps you group and label text at scale. Fast, reliable, and designed for teams.
          </p>
          <div className="hero-cta">
            <a className="button ghost" href="/register">Create free account</a>
          </div>
        </div>
        <div style={{ opacity: 0.8, color: 'var(--color-text-muted)' }}>
          Trusted by data-forward teams.
        </div>
      </div>
      <div className="auth-panel">
        <div className="card auth-card">
          <div className="auth-header">
            <h1 className="auth-title">{title}</h1>
            {subtitle && <div className="auth-subtitle">{subtitle}</div>}
          </div>
          <div className="auth-form">
            {children}
          </div>
          {footer && <div className="auth-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout; 